import { InformationPopupDataModel } from './InformationPopupDataModel';
import config from 'config';
import { get } from 'lodash';

export class InformationPopupDataManagementModel {
  
  get contentUrl() {
    if (!get(this.dataModel, 'resourceKey')) {
      return null;
    }
  
    return `${config.contextPopupBaseUrl}/${this.dataModel.resourceKey}`;
  }
  
  
  /** @type {InformationPopupDataModel} */
  dataModel;
  
  /**
   * @param {InformationPopupDataModel} dataModel
   */
  constructor(dataModel = new InformationPopupDataModel()) {
    this.dataModel = dataModel;
  }
  
}
